import { render, staticRenderFns } from "./AppNavBottomContent.vue?vue&type=template&id=03300453"
import script from "./AppNavBottomContent.vue?vue&type=script&lang=js"
export * from "./AppNavBottomContent.vue?vue&type=script&lang=js"
import style0 from "./AppNavBottomContent.vue?vue&type=style&index=0&id=03300453&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports